/**
 * @generated SignedSource<<93f8eee3ff69d50e143bf7020f49fdb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTimeRegInput = {
  id?: string | null;
  ids?: ReadonlyArray<string | null> | null;
  updateTimeRegLocation?: boolean | null;
  taskId?: string | null;
  idleTimeId?: string | null;
  projectId?: string | null;
  roleId?: string | null;
  year?: number | null;
  month?: number | null;
  day?: number | null;
  minutesRegistered?: number | null;
  billableMinutesRegistered?: number | null;
  retainerConflictHandled?: boolean | null;
  removeOthersForTheDay?: boolean | null;
  notes?: string | null;
  harvestTaskId?: string | null;
  retryHarvest?: boolean | null;
  unit4ActivityId?: string | null;
  unit4ActivityName?: string | null;
  skipApprovalValidation?: boolean | null;
  overrideInvoiced?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTimeRegistrationRetainerConflictMutation$variables = {
  input: UpdateTimeRegInput;
};
export type updateTimeRegistrationRetainerConflictMutation$data = {
  readonly updateTimeReg: {
    readonly timeRegs: ReadonlyArray<{
      readonly id: string;
      readonly retainerConflictHandled: boolean | null;
    } | null> | null;
  } | null;
};
export type updateTimeRegistrationRetainerConflictMutation = {
  variables: updateTimeRegistrationRetainerConflictMutation$variables;
  response: updateTimeRegistrationRetainerConflictMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTimeRegPayload",
    "kind": "LinkedField",
    "name": "updateTimeReg",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "timeRegs",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retainerConflictHandled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTimeRegistrationRetainerConflictMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTimeRegistrationRetainerConflictMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7bbd8e9b9bca045f73e1ec259b3843fd",
    "id": null,
    "metadata": {},
    "name": "updateTimeRegistrationRetainerConflictMutation",
    "operationKind": "mutation",
    "text": "mutation updateTimeRegistrationRetainerConflictMutation(\n  $input: UpdateTimeRegInput!\n) {\n  updateTimeReg(input: $input) {\n    timeRegs {\n      id\n      retainerConflictHandled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ccadd9d9180e46461fe1892098dd341a";

export default node;
